import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { clearAdminAuth, setCsrfToken } from "../lib/api";
import logo from "../printmytees-logo.png";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      clearAdminAuth();
      const { data } = await api.post("/auth/login", { email, password });
      // The server sets the HttpOnly auth cookie. Only the CSRF token is
      // returned to JavaScript, and it is held in memory for this page session.
      setCsrfToken(data?.csrf_token);
      toast.success("Welcome, admin");
      nav("/admin/dashboard", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || err?.message || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container-pmt py-12 sm:py-16" data-testid="admin-login">
      <div className="flex justify-center mb-8">
        <img
          src={logo}
          alt="PrintMyTees"
          className="h-16 sm:h-20 w-auto object-contain"
          data-testid="admin-login-logo"
        />
      </div>
      <div className="max-w-md mx-auto card-pmt p-8">
        <div className="overline">Admin</div>
        <h1 className="display-h2 mt-2">Sign In</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <div className="label-pmt">Email</div>
            <input required type="email" className="input-pmt" value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="admin-email" />
          </div>
          <div>
            <div className="label-pmt">Password</div>
            <input required type="password" className="input-pmt" value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="admin-password" />
          </div>
          <button disabled={busy} className="btn-primary w-full disabled:opacity-60" data-testid="admin-submit">{busy?"Signing in…":"Sign In"}</button>
        </form>
      </div>
    </div>
  );
}
